<script>
    export default {
        data() {
            return {
                attributeValues: null,
                newValue: {},
                languages: []
            }
        },
        props: {
            attributeValueIds: {
                type: Array
            },
            isOpen: {
                type: Boolean,
                default: false
            },
        },
        watch: {
            attributeValues(attributeValues) {
                let attributeWithTranslations = _.mapValues(attributeValues, (attributeValue) => {
                    return _.mapValues(_.mapKeys(attributeValue.translations, 'language_id'), 'text');
                });

                _.each(attributeValues, (attributeValue) => {
                    _.each(attributeValue.translations, (translation) => {

                        if (this.newValue[translation.language_id]) {
                            return;
                        }

                        let allOfLanguage = _.mapValues(attributeWithTranslations, (translations) => {
                            return translations[translation.language_id];
                        });

                        this.$set(this.newValue, translation.language_id, _.first(_.filter(allOfLanguage)));
                    });
                });
            },
            isOpen: {
                immediate: true,
                handler(newValue) {
                    if (newValue) {
                        this.languages = [];
                        this.attributeValues = null;
                        this.loadData();

                        this.$nextTick(() => {
                            $(this.$refs.combineCorrectAttributeModal).on('hidden.bs.modal', () => {
                                this.close();
                            }).modal('show');
                        });
                    }
                },
            }
        },
        methods: {
            saveAttributeValue() {
                axios.post(Scoop.baseUrl + '/edito/components/combine-correct-attribute-values', {
                    ids: this.attributeValueIds,
                    newValue: this.newValue
                })
                    .then(response => {
                        toastr.info('Attribute values saved');
                        window.location.reload(true);
                    }).catch(error => {
                        toastr.error(error.response.data.message, 'Could not correct attribute values', {timeOut: 5000});
                    });
            },
            loadData() {
                axios.get(Scoop.baseUrl + '/edito/components/combine-correct-attribute-values', {
                    params: {
                        ids: this.attributeValueIds
                    }
                }).then((response) => {
                    this.languages = response.data.languages;
                    this.attributeValues = response.data.attributeValues;
                }).catch((error) => {
                    toastr.error(error, 'Could not load data', {timeOut: 5000});
                });
            },
            setTranslation(languageId, text) {
                this.$set(this.newValue, languageId, text);
            },
            takeAll(translations) {
                _.each(translations, (translation) => {
                    this.$set(this.newValue, translation.language_id, translation.text);
                });
            },
            close() {
                this.$emit('close');
            },
        },
    }
</script>

<template>
    <div id="combine-correct-attribute-values" ref="combineCorrectAttributeModal" class="modal inmodal" tabindex="-1"
         role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">

                    <button type="button" class="close" data-dismiss="modal">
                        <span aria-hidden="true">&times;</span>
                        <span class="sr-only" v-text="__('scoop-os.labels.close')"></span>
                    </button>
                    <h4 class="modal-title" v-text="__('scoop-os.attributes.combine-values.headline')"></h4>
                    <small class="font-bold">
                        <span v-if="!attributeValues">Loading...</span>
                        <span v-if="attributeValues"></span>
                    </small>

                </div>
                <div class="modal-body">

                    <div v-if="attributeValues" class="ibox">
                        <div class="ibox-title">
                            <h5>
                                {{ __('scoop-os.attributes.combine-values.new-translations.headline') }}
                                <small
                                        class="m-l-sm"
                                        v-text="__('scoop-os.attributes.combine-values.new-translations.subheadline')">
                                </small>
                            </h5>
                        </div>
                        <div class="ibox-content">

                            <table class="table">
                                <tbody>
                                <tr v-for="language in languages">
                                    <td v-text="language.language_name"
                                        :class="{'font-bold': language.isBaseLanguage}"></td>
                                    <td>
                                        <input type="text"
                                               style="width: 100%"
                                               v-model="newValue[language.id]"
                                        >
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>
                                        <a @click="saveAttributeValue"
                                           class="btn btn-primary"
                                           v-text="__('scoop-os.attributes.combine-values.save-button')">
                                        </a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="row m-t-lg">
                        <div class="col-lg-12">
                            <div class="panel-body">

                                <div v-if="!attributeValues" class="text-center">
                                    <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i><br>
                                </div>
                                <div v-if="attributeValues">

                                    <div class="panel-group" id="accordion">
                                        <div v-for="(attributeValue, index) in attributeValues"
                                             class="panel panel-default">
                                            <div class="panel-heading">
                                                <h5 class="panel-title">
                                                    <a
                                                            data-toggle="collapse"
                                                            data-parent="#accordion"
                                                            :href="'#attributeValue'+attributeValue.id"
                                                            v-text="attributeValue.text">
                                                    </a>
                                                    <a class="pull-right m-l-sm"
                                                       title="Take over all languages"
                                                       @click="takeAll(attributeValue.translations)">
                                                        <i class="fa fa-share-square-o" aria-hidden="true"></i>
                                                    </a>
                                                    <span
                                                            class="badge badge-success small b-r-md pull-right"
                                                            v-text="attributeValue.assignments_count">
                                                    </span>
                                                </h5>
                                            </div>
                                            <div :id="'attributeValue'+attributeValue.id"
                                                 class="panel-collapse collapse"
                                                 :class="index === 0 ? 'in' : ''"
                                            >
                                                <div class="panel-body">
                                                    <div class="ibox">
                                                        <div class="ibox-content no-padding">
                                                            <ul class="list-group">
                                                                <li v-for="translation in attributeValue.translations"
                                                                    class="list-group-item">
                                                                    <span
                                                                            class="badge badge-primary pull-left"
                                                                            style="width: 45px"
                                                                            v-text="translation.language.language_code"
                                                                    >
                                                                    </span>
                                                                    <span
                                                                            class="m-l-sm pull-left"
                                                                            :class="{ 'font-bold': newValue[translation.language_id] === translation.text}"
                                                                            v-text="translation.text">
                                                                    </span>

                                                                    <a
                                                                            v-if="newValue[translation.language_id] !== translation.text"
                                                                            @click="setTranslation(translation.language_id, translation.text)"
                                                                            class="m-l-sm"
                                                                    >
                                                                            <i class="fa fa-share-square-o" aria-hidden="true"></i>
                                                                    </a>
                                                                    <i v-else
                                                                       class="fa fa-check m-l-xs"
                                                                       aria-hidden="true"></i>

                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
